type WorkspaceInfo = {
	title: string;
	description: string;
	status: string;
};

const getHeroSectionText = (mdxNode: any, workspaceInfo: WorkspaceInfo) => {
	if (mdxNode && mdxNode.frontmatter.title) {
		let { title, description } = mdxNode.frontmatter;
		let { status } = workspaceInfo;
		return {
			title,
			description,
			status,
		};
	} else {
		let { title, description, status } = workspaceInfo;
		return { title, description, status };
	}
};

export default getHeroSectionText;
